import '../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import { findLocaleFromUrlAndCookie, findSiteFromUrl } from '../node_modules/@zooplus/commons-lang/dist/es/services/cookieService.js';
import { findDeploymentEnvFromUrl } from '../node_modules/@zooplus/commons-lang/dist/es/services/envService.js';
import '../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';
import { DEFAULT_LOCALE, DEFAULT_SITE_ID, DEFAULT_DOMAIN, DEFAULT_CURRENCY, REALM } from '../config.js';

const extractRealm = () => {
    const nsRegex = /(zoo|bitiba)/;
    const ns = document.location.hostname.match(nsRegex) ?? ['zoo'];
    return (ns[0] === 'zoo' ? REALM.ZOOPLUS : REALM.BITIBA);
};
const getAppConfig = () => {
    const locale = findLocaleFromUrlAndCookie() || DEFAULT_LOCALE;
    const realm = extractRealm();
    const site = findSiteFromUrl();
    return {
        shop: {
            siteId: site?.id ?? DEFAULT_SITE_ID,
            domain: site?.domain ?? DEFAULT_DOMAIN,
            locales: [locale],
            currency: site?.alternativeCurrency ?? DEFAULT_CURRENCY,
        },
        locale,
        realm,
        environment: findDeploymentEnvFromUrl(),
    };
};

export { extractRealm, getAppConfig };
//# sourceMappingURL=app-configs-utils.js.map
